// extracted by mini-css-extract-plugin
module.exports = {"container":"Disclaimer_container__1p3OQ","content":"Disclaimer_content__2KnF0"};